export default __webpack_public_path__ + "static/media/AccordianUPBlack.97852a94.svg";